"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _Separator = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _Heading = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Heading"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _reactIntl = require("react-intl");
var _SocialsLogin = _interopRequireDefault(require("./SocialsLogin"));
var _EmailLogin = _interopRequireDefault(require("./EmailLogin"));
var _context = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _context2 = require("../../../../services/intl/context");
var _context3 = require("../../../../services/brand/context");
var _Logo = _interopRequireDefault(require("../../../Logo"));
var _usePublishLoginScreenDisplayed = _interopRequireDefault(require("../../consts/events/business/usePublishLoginScreenDisplayed"));
var _usePublishLoginStarted = _interopRequireDefault(require("../../consts/events/business/usePublishLoginStarted"));
var _usePublishLoginButtonClicked = _interopRequireDefault(require("../../consts/events/business/usePublishLoginButtonClicked"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _FormattedMessage2, _FormattedMessage3, _FormattedMessage4, _FormattedMessage5, _Fragment2, _FormattedMessage6;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NewIntroScreen = _ref => {
  let {
    onChangeScreen,
    screen,
    onOtpTransactionIdChange,
    onEmailChange,
    email,
    onEmailCorrection,
    emailSuggestion,
    disableSocialLogin
  } = _ref;
  const {
    log
  } = (0, _context.useLog)();
  const {
    language
  } = (0, _context2.useIntl)();
  const brand = (0, _context3.useBrand)();
  const publishLoginScreenDisplayed = (0, _usePublishLoginScreenDisplayed.default)();
  const publishLoginStarted = (0, _usePublishLoginStarted.default)();
  const publishLoginButtonClicked = (0, _usePublishLoginButtonClicked.default)();
  (0, _react.useEffect)(() => {
    if (screen === "newIntroSignIn") {
      publishLoginScreenDisplayed("user_click", "signin");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // We want to log the screen only when the component is mounted

  const handleIncorrectEmail = () => {
    log(_events.GET_SIMPLE_TOKEN, {});
    publishLoginStarted("alternative_signin");
    onChangeScreen("getSingleBooking");
  };
  const handleSignInClick = () => {
    publishLoginButtonClicked("login_screen_signin_button");
    publishLoginScreenDisplayed("user_click", "signin");
    onChangeScreen("newIntroSignIn");
  };
  const handleSignUpClick = () => {
    publishLoginButtonClicked("login_screen_signup_button");
    publishLoginScreenDisplayed("user_click", "signup");
    onChangeScreen("newIntroSignUp");
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center flex-col pt-[32px]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Logo.default, {
        id: brand === null || brand === void 0 ? void 0 : brand.id,
        title: brand === null || brand === void 0 ? void 0 : brand.name,
        redirectUrl: "",
        url: brand === null || brand === void 0 ? void 0 : brand.base_url
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        margin: {
          top: "600",
          bottom: "200"
        },
        dataTest: "MagicLogin-NewIntro",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Heading.default, {
          type: "title2",
          id: "magic-login-header",
          children: [screen === "newIntroSignUp" && (_FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.create_account"
          }))), screen === "newIntroSignIn" && (_FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.common.sign_in"
          })))]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        display: "flex",
        align: "center",
        children: [screen === "newIntroSignUp" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            as: "span",
            margin: {
              right: 4
            },
            children: _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.common.has_account"
            }))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
            asComponent: "button",
            onClick: handleSignInClick,
            children: _FormattedMessage4 || (_FormattedMessage4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.sign_in"
            }))
          })]
        }), screen === "newIntroSignIn" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            as: "span",
            margin: {
              right: 4
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.common.need_account",
              values: {
                brandName: "Kiwi.com"
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
            asComponent: "button",
            onClick: handleSignUpClick,
            children: _FormattedMessage5 || (_FormattedMessage5 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "common.signup"
            }))
          })]
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ModalSection.default, {
      dataTest: "MagicLogin-PasswordlessIntro",
      children: [!disableSocialLogin && (_Fragment2 || (_Fragment2 = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialsLogin.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex items-center justify-center py-700",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator.default, {
            label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "common.or"
            })
          })
        })]
      }))), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailLogin.default, {
        email: email,
        onEmailChange: onEmailChange,
        onEmailCorrection: onEmailCorrection,
        onOtpTransactionIdChange: onOtpTransactionIdChange,
        onChangeScreen: onChangeScreen,
        screen: screen,
        emailSuggestion: emailSuggestion
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        display: "flex",
        align: "center",
        textAlign: "center",
        direction: "column",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          margin: {
            bottom: "600"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
            asComponent: "button",
            type: "secondary",
            dataTest: "MagicLogin-IncorrectEmail",
            onClick: handleIncorrectEmail,
            size: "small",
            children: _FormattedMessage6 || (_FormattedMessage6 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.incorrect_booking_email"
            }))
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "secondary",
          size: "small",
          dataTest: "MagicLogin-LegalText",
          align: "center",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "account.login_modal.terms_of_use",
            values: {
              a1: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                href: `/${language.id}/pages/content/terms`,
                rel: "noreferrer noopener",
                target: "_blank",
                children: text
              }),
              a2: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                href: `/${language.id}/pages/content/privacy`,
                rel: "noreferrer noopener",
                target: "_blank",
                children: text
              })
            }
          })
        })]
      })]
    })]
  });
};
var _default = exports.default = NewIntroScreen;